import task from "./task";
import taskItem from "./taskItem";
import template from "./template";
import templateItem from "./templateItem";
import taskDanger from "./taskDanger";
import taskDevice from "./taskDevice";


export default { task, taskItem, template, templateItem, taskDanger, taskDevice }